import React from 'react';
import { useTranslation } from 'react-i18next';

import { getPicturePath } from '../../Functions/GetIconPath';
import { useAppSelector } from '../../redux/store';

import styles from './MaintenanceScreen.module.scss';

const formatEta = (eta: string | null) => {
  if (!eta) {
    return null;
  }

  const date = new Date(eta);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleString(undefined, {
    hour: '2-digit',
    minute: '2-digit'
  });
};

const MaintenanceScreen: React.FC = () => {
  const { t } = useTranslation();
  const eta = useAppSelector((state) => state.auth.maintenance.eta);
  const formattedEta = formatEta(eta);

  return (
    <div className={styles.MaintenanceScreen}>
      <h2 className={styles.title}>{t('maintenance.title')}</h2>
      <p className={styles.text}>{t('maintenance.description')}</p>
       <img
            srcSet={`${getPicturePath('emptyScreen')}, ${getPicturePath('emptyScreen@2x')}`}
            className={styles.picture}
            alt="Empty Screen"
        />
      {formattedEta && (
        <p className={styles.eta}>{t('maintenance.eta', { time: formattedEta })}</p>
      )}
    </div>
  );
};

export default MaintenanceScreen;
